/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {useTranslation} from 'react-i18next';

import BolmateStatusTile, {StatusTileState} from './bolmateStatusTile';

interface Props {
    state?: StatusTileState;
    onClick?: () => void;
    className?: string;
}

export default function BolmateAutoUploadStatus(props: Props) {
    const {state = 'green', onClick, className} = props;
    const {t} = useTranslation();

    // Never red: leaving auto upload off is a preference, not a fault.
    const labels: Record<StatusTileState, string> = {
        green: t('controls.statusTile.autoUpload.green', 'Auto uploaden'),
        gray: t('controls.statusTile.autoUpload.gray', 'Auto uploaden uit'),
        orange: t('controls.statusTile.autoUpload.orange', 'Auto uploaden vertraagd'),
        red: t('controls.statusTile.autoUpload.red', 'Auto uploaden uit')
    };

    return <BolmateStatusTile className={className} label={labels[state]} state={state} onClick={onClick} />;
}
